<form *ngIf="formGallery" [formGroup]="formGallery">
    <div class="flex flex-col justify-content self-stretch gap-8 p-4 md:p-8">
        <div class="section1 mb-8">
            <div class="section1Container p-4 md:p-8">
                <div class="header">
                    <span class="typography-title-m infoHeader">{{ 'my_galleries.modal_new_gallery_body_title' | translate }}</span>
                </div>
                <div class="inputs">
                    <div class="frame">
                        <div class="rowTablet">
                            <div class="classInput">
                                <label class="form-label typography-body-m-medium">
                                    {{ 'my_galleries.modal_new_gallery_gallery_name' | translate }}
                                    <span class="we-required">*</span>
                                </label>
                                <input
                                    formControlName="galleryName"
                                    class="inputLine typography-body-m-regular M"
                                    type="text"
                                    name="Name"
                                    placeholder="{{ 'my_galleries.modal_new_gallery_gallery_name_pholder' | translate }}"
                                    required=""
                                    [class.disabled]="!creating"
                                />
                            </div>

                            <div class="w-full" *ngIf="categories && categories.length > 0">
                                <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_galleries.categoria' | translate }}</p>
                                <app-select
                                    [disabled]="!creating"
                                    [placeholder]="'my_galleries.new_gallery_select_category' | translate"
                                    [options]="categoryOptions"
                                    [selectedValue]="getSelectedCategory()"
                                    [required]="true"
                                    (selectedValueChanged)="selectCategory($event)">
                                </app-select>
                            </div>

                            <div class="w-full" *ngIf="spaces && spaces.length > 0">
                                <p class="m-0 mb-2 typography-body-m-medium">{{ 'new-galleries.field-space' | translate }}</p>
                                <app-select
                                    [disabled]="!creating"
                                    [placeholder]="'my_galleries.new_gallery_select_category' | translate"
                                    [options]="spaceOptions"
                                    [selectedValue]="getSelectedSpace()"
                                    [required]="true"
                                    (selectedValueChanged)="selectSpace($event)">
                                </app-select>
                            </div>

                            <div class="w-full" *ngIf="collaborators && collaborators.length > 0">
                                <p class="m-0 mb-2 typography-body-m-medium">{{ 'my_galleries.colaboradores' | translate }}</p>
                                <app-select
                                    [disabled]="!creating"
                                    [placeholder]="'my_galleries.new_gallery_select_fabricator_pholder' | translate"
                                    [options]="collaboratorOptions"
                                    [selectedValue]="getSelectedCollab()"
                                    [required]="true"
                                    (selectedValueChanged)="selectCollabs($event)">
                                </app-select>
                                <div class="textInputs">
                                    <span class="typography-body-s-regular">
                                        {{ 'new-galleries.advice-1' | translate }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                      <div class="textArea">
                          <label class="typography-body-m-medium">
                              {{ 'new-galleries.field-description' | translate }}
                              <abbr>*</abbr>
                          </label>
                          <textarea
                              formControlName="description"
                              name="Description__c"
                              placeholder="{{ 'new-galleries.hint-description' | translate }}"
                              required=""
                              class="inputLine typography-body-m-regular textArea_field"
                              [class.disabled]="!creating"
                              (blur)="onDescriptionBlur()"
                          ></textarea>
                          <div class="w-full error-message flex flex-row justify-content">
                            <div *ngIf="formGallery.get('description')?.errors && formGallery.get('description')?.touched" class="error-message__text semanticError-color typography-body-s-regular">{{'YOUR_MESSAGE_IS_TOO_SHORT' | translate }}</div>
                            <div class="character-count typography-body-s-regular flex-1 basis-[25%]">{{ descriptionCharacterCount }} / 24-640</div>
                          </div>

                          <div class="group">
                            <span class="typography-body-s-regular">
                                {{ 'new-galleries.advice-2' | translate }}
                            </span>
                        </div>
                      </div>
                </div>
                <div class="cards">
                    <input type="hidden" formControlName="style" />

                    <div class="cardsContent">
                        <span class="typography-body-m-medium styleText">
                            {{ 'new-galleries.field-style' | translate }}
                            <abbr>*</abbr>
                        </span>

                        <div class="list-container grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 md:gap-x-6 gap-y-4 justify-start">
                            <div
                                *ngFor="let style of styles"
                                class="style-wrapper"
                                [class.selected2]="selectedStyle === style"
                                [class.disabled]="!creating"
                                (click)="creating && selectStyle(style)"
                            >
                                <div class="style-item">
                                    <img src="assets/images/my-galleries/styles/{{ style }}.jpg" [alt]="style" />
                                    <span>{{ "gallery-style." + style | translate }}</span>
                                </div>
                            </div>
                        </div>

                        <span class="typography-body-m-regular styleText">
                          <abbr>*</abbr>
                          {{ 'new-galleries.fields-mandatory' | translate }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="section2">
            <div class="infoBox">
                <div class="colum1InfoBox">
                    <span class="typography-title-m textPrimary-color">
                        {{ 'new-galleries.subtitle-tips' | translate }}
                    </span>
                </div>
                <div class="textInfoBox">
                    <div class="colum2InfoBox">
                        <div class="parragraph2Title">
                            <span class="typography-body-l-medium textPrimary-color">
                                {{ 'new-galleries.content-tips-1' | translate }}
                            </span>
                        </div>
                        <div class="parragraph2Desc">
                            <ul>
                                <li>{{ 'new-galleries.content-tips-2' | translate }}</li>
                                <li>{{ 'new-galleries.content-tips-3' | translate }}</li>
                                <li>{{ 'new-galleries.content-tips-4' | translate }}</li>
                            </ul>
                        </div>
                    </div>
                    <div class="colum3InfoBox">
                        <div class="parragraph3Title">
                            <span class="typography-body-l-medium textPrimary-color">
                                {{ 'new-galleries.content-tips-5' | translate }}
                            </span>
                        </div>
                        <div class="parragraph3Desc">
                            <ul>
                                <li>{{ 'new-galleries.content-tips-6' | translate }}</li>
                                <li>{{ 'new-galleries.content-tips-7' | translate }}</li>
                                <li>{{ 'new-galleries.content-tips-8' | translate }}</li>
                                <li>{{ 'new-galleries.content-tips-9' | translate }}</li>
                                <li>{{ 'new-galleries.content-tips-10' | translate }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="gallery_photos">
                <app-gallery-photos [images]="gallery.images" (imagesUploaded)="onImagesUploaded($event)" [creating]="creating" (validateChanges)="onGalleryPhotosValidate($event)"> </app-gallery-photos>
            </div>
        </div>
    </div>
</form>
